var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#E86E7B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_941_5222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 27H29V17C29 16.7348 28.8946 16.4804 28.7071 16.2929C28.5196 16.1054 28.2652 16 28 16V16C27.7348 16 27.4804 16.1054 27.2929 16.2929C27.1054 16.4804 27 16.7348 27 17V27H17C16.7348 27 16.4804 27.1054 16.2929 27.2929C16.1054 27.4804 16 27.7348 16 28V28C16 28.2652 16.1054 28.5196 16.2929 28.7071C16.4804 28.8946 16.7348 29 17 29H27V39C27 39.2652 27.1054 39.5196 27.2929 39.7071C27.4804 39.8946 27.7348 40 28 40C28.2652 40 28.5196 39.8946 28.7071 39.7071C28.8946 39.5196 29 39.2652 29 39V29H39C39.2652 29 39.5196 28.8946 39.7071 28.7071C39.8946 28.5196 40 28.2652 40 28C40 27.7348 39.8946 27.4804 39.7071 27.2929C39.5196 27.1054 39.2652 27 39 27Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_941_5222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPlus);
export default __webpack_public_path__ + "static/media/Button_plus.223791038fbafbe2a73f103436f77d78.svg";
export { ForwardRef as ReactComponent };